angular.module('pixi', []);

angular.module('pixi')
.constant('PIXI', PIXI)
